import { useEffect, useState } from 'react';
import styles from './WorldCupBanner.module.css';

import stadiumImg from '../assets/wc2026/stadium.png';
import fansImg from '../assets/wc2026/fans.png';

const TARGET_DATE = new Date('2026-06-11T20:00:00-05:00');

const WorldCupBanner = ({ onWatchLive, onViewSchedule }) => {
  const [visible, setVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const diff = TARGET_DATE - now;

      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / 1000 / 60) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  const pad = (num) => String(num).padStart(2, '0');

  return (
    <article
      className={`${styles.bannerContainer} ${visible ? styles.isVisible : ''}`}
      aria-label="Mundial FIFA 2026"
    >
      <div className={styles.bannerBackground}>
        <img src={stadiumImg} className={styles.bgImage} alt="" aria-hidden="true" />
        <img src={fansImg} className={styles.bgImageRight} alt="" aria-hidden="true" />
        <div className={styles.atmosphere}>
          <div className={`${styles.blob} ${styles.blobGold}`} />
          <div className={`${styles.blob} ${styles.blobAmber}`} />
          <div className={styles.goldShine} />
          <div className={styles.dotPattern} />
        </div>
      </div>

      <div className={styles.goldFrame} aria-hidden="true" />

      <div className={styles.columnLeft}>
        <div className={`${styles.badge} ${styles.reveal} ${styles.d1}`}>
          <span className={styles.trophyIcon} aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M5 3h14v2H5V3zm2 2h10l1 4c0 3.5-2 6.5-5 8v3h4v2H7v-2h4v-3c-3-1.5-5-4.5-5-8l1-4zm5 14a6 6 0 0 0 5-7.5l-.5-2H8.5L8 11.5A6 6 0 0 0 12 19z" />
            </svg>
          </span>
          <span>IPTV Premium · En directo</span>
        </div>

        <p className={`${styles.eyebrow} ${styles.reveal} ${styles.d2}`}>
          Vive más cerca que nunca del
        </p>

        <h2 className={`${styles.headline} ${styles.reveal} ${styles.d3}`}>
          Mundial FIFA <span className={styles.goldText}>2026</span>
        </h2>

        <p className={`${styles.subline} ${styles.reveal} ${styles.d4}`}>
          Todos los partidos en calidad premium — 4K, FHD y sin cortes
        </p>

        <div className={`${styles.ctaGroup} ${styles.reveal} ${styles.d5}`}>
          <button type="button" className={styles.btnPrimary} onClick={onWatchLive}>
            Ver en directo
          </button>
          <button type="button" className={styles.btnSecondary} onClick={onViewSchedule}>
            Ver planes
          </button>
        </div>

        <p className={`${styles.bottomNote} ${styles.reveal} ${styles.d6}`}>
          Pase IPTV · Activación instantánea · Cancela cuando quieras
        </p>
      </div>

      <div className={styles.columnRight}>
        <p className={`${styles.countdownTitle} ${styles.reveal} ${styles.d3}`}>
          Cuenta atrás al inicio
        </p>

        <div className={`${styles.timerGrid} ${styles.reveal} ${styles.d4}`}>
          {[
            { value: timeLeft.days, label: 'Días' },
            { value: pad(timeLeft.hours), label: 'Horas' },
            { value: pad(timeLeft.minutes), label: 'Min' },
            { value: pad(timeLeft.seconds), label: 'Seg', pulse: true },
          ].map((item) => (
            <div
              key={item.label}
              className={`${styles.timerCard} ${item.pulse ? styles.timerPulse : ''}`}
            >
              <span className={styles.timerValue}>{item.value}</span>
              <span className={styles.timerLabel}>{item.label}</span>
            </div>
          ))}
        </div>

        <div className={`${styles.featuresGrid} ${styles.reveal} ${styles.d5}`}>
          <div className={styles.featureItem}>
            <span className={styles.fLabel}>Evento</span>
            <span className={styles.fValue}>Live + VOD</span>
          </div>
          <div className={styles.vDivider} />
          <div className={styles.featureItem}>
            <span className={styles.fLabel}>Acceso</span>
            <span className={styles.fValue}>Todos los partidos</span>
          </div>
          <div className={styles.vDivider} />
          <div className={styles.featureItem}>
            <span className={styles.fLabel}>Calidad</span>
            <span className={styles.fValue}>4K UHD / FHD</span>
          </div>
        </div>
      </div>
    </article>
  );
};

export default WorldCupBanner;
